import { takeCustomLatest } from 'state/common/common.effects'
import {
  fetchBrandSummaryEffect,
  fetchBrandReportEffect,
  downloadBrandReportEffect,
  fetchBrandProductMappingEffect,
  uploadBrandProductMappingEffect,
  setFilterPaginationDataEffect
} from 'state/new-summary/brand/brand.effects'
import { BrandSummaryActions, setLoaderAction } from './brand.actions'

function* getBrandSummarySummarySaga() {
  yield takeCustomLatest(
    BrandSummaryActions.FETCH_BRAND_SUMMARY_DATA,
    fetchBrandSummaryEffect,
    () => setLoaderAction({ id: 'outerGroupSummary', value: false })
  )
}

function* getBrandProductMappingSaga() {
  yield takeCustomLatest(
    BrandSummaryActions.FETCH_BRAND_PRODUCT_MAPPING,
    fetchBrandProductMappingEffect,
    () => setLoaderAction({ id: 'fetchingProductMapping', value: false })
  )
}

function* uploadBrandProductMappingSaga() {
  yield takeCustomLatest(
    BrandSummaryActions.UPLOAD_BRAND_PRODUCT_MAPPING,
    uploadBrandProductMappingEffect,
    () => setLoaderAction({ id: 'uploadingProductMapping', value: false })
  )
}

function* getBrandReportSaga() {
  yield takeCustomLatest(BrandSummaryActions.FETCH_BRAND_REPORT, fetchBrandReportEffect, () =>
    setLoaderAction({ id: 'innerSummaryItems', value: false })
  )
}

function* setFilterPaginationDataSaga() {
  yield takeCustomLatest(
    BrandSummaryActions.SET_FILTER_PAGINATION_DATA,
    setFilterPaginationDataEffect
  )
}

function* downloadBrandReportSaga() {
  yield takeCustomLatest(BrandSummaryActions.DOWNLOAD_BRAND_REPORT, downloadBrandReportEffect)
}

export const BrandSummaryWatcher = [
  getBrandSummarySummarySaga(),
  getBrandReportSaga(),
  downloadBrandReportSaga(),
  getBrandProductMappingSaga(),
  uploadBrandProductMappingSaga(),
  setFilterPaginationDataSaga()
]
